import InvitePage from "./invite-page";

export default InvitePage;
